export enum AccessLevelsEnum {
  PROJECT = "PROJECT",
  USERS = "USERS",
  GROUPS = "GROUPS",
}

export const AccessNorwegianEnum = {
  PROJECT: "Prosjekt",
  USERS: "Brukere",
  GROUPS: "Grupper",
};

export enum AccessGroupsEnum {
  INTERNAL = "INTERNAL",
  CLIENT = "CLIENT",
  PARTNER = "PARTNER",
  ADMIN = "ADMIN",
}

export enum IssueViewEnum {
  TABLE = "TABLE",
  GIS = "GIS",
  KANBAN = "KANBAN",
  NOTEBOARD = "NOTEBOARD",
  DASHBOARD = "DASHBOARD",
  PNS = "PNS",
  GANTT = "GANTT",
  BIM = "BIM",
  "NONE" = "NONE",
}

export enum IssueDisabledColumnsEnum {
  BUCKET = "bucket",
  CONNECTEDBIMSPACES = "connectedBimSpaces",
  DATESSECTION = "datesSection",
  DATESPLANNEDSTART = "dates.plannedStart",
  DATESDUE = "dates.due",
  HOURSORIGINALESTIMATE = "hours.orignalEstimate",
  HOURSCOMPLETED = "hours.completed",
  HOURSREMAINING = "hours.remaining",
  PRIORITY = "priority",
  STATUS = "status",
  ITEMMEMBERS = "itemMembers",
  ASSIGNEDTO = "assignedTo",
  OWNER = "owner",
  DESCRIPTION = "description",
  CONCLUSION = "conclusion",
  PNS = "pns",
  REFERENCEURL = "referenceUrl",
  SPACE = "space",
  TYPEOFISSUE = "typeOfIssue",
}

export enum IssueFieldEnum {
  ID = "id",
  TITLE = "title",
  PNS = "pns",
  CREATEDBY_ID = "createdBy._id",
  CREATEDBY_NAME = "createdBy.name",
  LASTUPDATEDBY_ID = "lastUpdatedBy._id",
  LASTUPDATEDBY_NAME = "lastUpdatedBy.name",
  OWNER = "owner",
  OWNER_ID = "owner._id",
  OWNER_NAME = "owner.name",
  ASSIGNEDTO_NAME = "assignedTo.name",
  ASSIGNED_TO = "assignedTo",
  ASSIGNED_TO_ID = "assignedTo._id",
  UPDATEDAT = "updatedAt",
  CREATEDAT = "createdAt",
  DATES = "dates",
  DATES_PLANNEDSTART = "dates.plannedStart",
  DATES_DUE = "dates.due",
  DATES_COMPLETED = "dates.completed",
  TAGS = "tags",
  STATUS = "status",
  PRIORITY = "priority",
  DESCRIPTION = "description",
  CONCLUSION = "conclusion",
  REFERENCEURL = "referenceUrl",
  DISCIPLIN = "assignedTo.discipline",
  TYPEOFISSUE = "typeOfIssue",
  CONNECTEDBIMSPACES = "connectedBimSpaces",
  GIS = "gis",
  BUCKET = "bucket",
  HOURS = "hours",
  HOURS_ORIGNALESTIMATE = "hours.orignalEstimate",
  HOURS_REMAINING = "hours.remaining",
  HOURS_COMPLETED = "hours.completed",
  ITEMMEMBERS = "itemMembers",
  ITEMMEMBERS_ID = "itemMembers._id",
  ITEMMEMBERS_NAME = "itemMembers.name",
  TASK_OR_ISSUE = "taskOrIssue",
  MINE_SAKER = "mineSaker",
  DUE_DATE = "dueDate",
  RISK_PROBABILITY = "risiko.probability",
  RISK_CATEGORY_COMMENT = "risiko.categoryComment",
  TODOS = "todos",
}

export const ChecklistDisciplineRoles = [
  { code: "ARK", title: "ARK - Arkitekt" },
  { code: "BIM", title: "BIM - BIM koordinering" },
  { code: "BL", title: "BL - Byggeledelse" },
  { code: "BREEAM", title: "BREEAM - BREEAM sertifisering" },
  { code: "GIS", title: "GIS - Geografiske informasjonssystemer" },
  { code: "KOST", title: "KOST - Kostestimering" },
  { code: "LARK", title: "LARK - Landskapsarkitek" },
  { code: "PGK", title: "PGK - Prosjektgruppekoordinator" },
  { code: "PGL", title: "PGL - Prosjektgruppeleder" },
  { code: "PL", title: "PL - Prosjektledelse inkl. SØK" },
  { code: "PLAN", title: "PLAN - Arealplanlegger" },
  { code: "PRO", title: "PRO - Prosess" },
  { code: "RIA", title: "RIA - Rådgivende ingengiør Akustikk" },
  { code: "RIAkva", title: "RIAkva - Rådgivende ingengiør Akvateknikk" },
  { code: "RIB", title: "RIB - Rådgivende ingeniør Bygg" },
  { code: "RIBfy", title: "RIBfy - Rådgivende ingeniør Bygningsfysikk" },
  { code: "RIBko", title: "RIBko - Rådgivende ingeniør Konstruksjoner" },
  { code: "RIBr", title: "RIBr - Rådgivende ingeniør Brann" },
  { code: "RIE", title: "RIE - Rådgivende ingeniør Elektroteknikk" },
  { code: "RIEaut", title: "RIEaut - Rådgivende ingeniør ITB & Automasjon" },
  { code: "RIElys", title: "RIElys - Rådgivende ingeniør Lysdesign" },
  { code: "RIEn", title: "RIEn - Rådgivende ingeniør Energi" },
  { code: "RIEsv", title: "RIEsv - Rådgivende ingeniør IKT & Sikkerhet" },
  { code: "RIFDV", title: "RIFDV - Rådgivende ingeniør FDV" },
  { code: "RIG", title: "RIG - Rådgivende ingeniør Geoteknikk" },
  { code: "RIGberg", title: "RIGberg - Rådgivende ingeniør GEO, Bergteknikk" },
  { code: "RIGbes", title: "RIGbes - Rådgivende ingeniør GEO, Besiktigelser" },
  { code: "RIGh", title: "RIGh - Rådgivende ingeniør Hydrologi" },
  { code: "RIGm", title: "RIGm - Rådgivende ingeniør GEO, Miljøgeologi" },
  { code: "RIGvib", title: "RIGvib - Rådgivende ingeniør GEO, Måleteknikk" },
  { code: "RIJ", title: "RIJ - Rådgivende ingeniør Jernbane" },
  { code: "RILU", title: "RILU - Rådgivende ingeniør Luftkvalitet" },
  { code: "RIM", title: "RIM - Rådgivende ingeniør Ytre Miljø" },
  { code: "RIMask", title: "RIMask - Rådgivende ingeniør Maskin" },
  { code: "RIMAT", title: "RIMAT - Rådgivende ingeniør Materialteknologi" },
  { code: "RIMAT-Lab", title: "RIMAT-Lab - Rådgivende ingeniør Materialteknologi Laboratorium" },
  { code: "RIMT", title: "RIMT - Rådgivende ingeniør Marin Teknologi" },
  { code: "RIS", title: "RIS - Rådgivende ingeniør Sikkerhet" },
  { code: "RISol", title: "RISol - Rådgivende ingeniør Solenergi" },
  { code: "RIT", title: "RIT - Rådgivende ingeniør Trafikk" },
  { code: "RITB", title: "RITB - Rådgivende ingeniør Integrerte Tekniske Bygningsinstallasjoner" },
  { code: "RIV", title: "RIV - Rådgivende ingeniør VVS (HVAC)" },
  { code: "RIVA", title: "RIVA - Rådgivende ingeniør Vann & Avløp" },
  { code: "RIVass", title: "RIVass - Rådgivende ingeniør Vassdragsteknikk" },
  { code: "RIVeg", title: "RIVeg - Rådgivende ingeniør Veg" },
  { code: "SHA", title: "SHA - Sikkerhet, Helse og Arbeidsmiljø" },
  { code: "SØK", title: "SØK - Ansvarlig søker" },
  { code: "TVF", title: "TVF - Tverrfaglig" },
  { code: "UAS", title: "UAS - Utredning, analyse og strategisk rådgivning" },
  { code: "Annet", title: "Annet - Annet" },
];

export const MC_CHECKLIST_TEMPLATES_DOCX = [
  "checklist_1col.docx",
  "checklist_2col.docx",
  "checklist_3col.docx",
] as const;
